import apiv3 from '../http-common/http-common-apiv3'

class APIv3{
    localizarPorPlaca(token, vistoriador, placa){
        return apiv3.get("/area-vistoriador/busca-placa/" 
            + token 
            + "/" + vistoriador
            + "/" + placa 
            )
    }
    getUltimas10Vistorias(token, vistoriador){
        return apiv3.get("/area-vistoriador/ultimas-10-vistorias/" + token + "/" + vistoriador)
    }
    localizarPorPeriodo(token, vistoriador, dataInicial, dataFinal){
        return apiv3.get("/area-vistoriador/periodo/" + token + "/" + vistoriador + "/" + dataInicial + "/" + dataFinal)
    }
    getDadosPessoaisJSON(vistoriador) {
        return apiv3.get(`/vistoriador/dados-pessoais/${vistoriador}`)
    }
    getPrecisaAtualizarPerfil (vistoriador) {
        return apiv3.get(`/vistoriador/precisa-atualizar-perfil/${vistoriador}`)
    }
    postDadosPessoais(data) {
        return apiv3.post(`/vistoriador/dados-pessoais`, data)
    }
    abrirRedefinicaoSenha(email, token) {
        return apiv3.post('/redefinicao-senha/requisitar', {email: email, token: token})
    }
    sendMail(idVistoria, email){
        return apiv3.get("/vistoria/" + idVistoria + "/reenviar-email/" + email)
    }
}

export default new APIv3()